import { render, staticRenderFns } from "./DashboardTitleSearch.vue?vue&type=template&id=1c2b0a4a&scoped=true&"
import script from "./DashboardTitleSearch.vue?vue&type=script&lang=js&"
export * from "./DashboardTitleSearch.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTitleSearch.vue?vue&type=style&index=0&id=1c2b0a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b0a4a",
  null
  
)

export default component.exports